import React, { Suspense, lazy, useEffect } from 'react';
import {Spin } from 'antd';
import { useLocation, useNavigate, Routes, Route } from 'react-router-dom';
import AppRoutes from './routes';
import { isLayoutPage } from './config/layoutConfig';
import { AuthProvider } from './auth/AuthContext';
import GlobalLoading from './components/GlobalLoading';
import { ConfigProvider } from 'antd';
import trTR from 'antd/es/locale/tr_TR';
import dayjs from 'dayjs';
import 'dayjs/locale/tr';
import NotFoundPage from './pages/NotFoundPage';
import { getCurrentFirmId } from './utils/role';

dayjs.locale('tr');

const AdminApp = lazy(() => import('./modules/admin'));
const IsgApp   = lazy(() => import('./modules/isg-platform'));
const FirmApp  = lazy(() => import('./modules/firm'));

const FirmGuard: React.FC = () => {
  const firmId = getCurrentFirmId();
  const navigate = useNavigate();

  useEffect(() => {
    if (!firmId) {
      navigate(-1);
    }
  }, [firmId, navigate]);

  if (!firmId) {
    return null;
  }

  return <FirmApp />;
};

const App: React.FC = () => {
  
  const location = useLocation();

  const FullScreenSpinner = (
    <div 
      style={{
        position: 'fixed',
        top: 0, left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <Spin size="large" tip="Yükleniyor..." />
      </div>
  );
  
  // Önce layout kontrolü yap
  if (!isLayoutPage(location.pathname)) {
    return <AppRoutes />;
  }


  return (
    <ConfigProvider locale={trTR}>
    <AuthProvider>
      <Suspense fallback={FullScreenSpinner}>
        <GlobalLoading/>
          <Routes>
            <Route path="/admin/*" element={<AdminApp />} />
            <Route path="/isg/*"   element={<IsgApp />}   />
            <Route path="/firm/*"  element={<FirmGuard />} />
            <Route path="*"        element={<NotFoundPage />} />
          </Routes>
      </Suspense>
    </AuthProvider>
    </ConfigProvider>
      
  );
};

export default App;